import type { AgentTodoItem, AgentTodoItemStatus } from './types';

const TERMINAL_STATUSES = new Set<AgentTodoItemStatus>(['completed', 'cancelled']);

/**
 * Forward-fill terminal statuses from the latest todo snapshot so older
 * transcript blocks don't keep showing spinners for work that finished later.
 * Non-terminal snapshot statuses (e.g. in_progress) are kept when the item
 * is still open in the latest state.
 */
export const mergeTodoItemsWithLatest = (
  snapshot: AgentTodoItem[],
  latestById: ReadonlyMap<number, AgentTodoItem>
): AgentTodoItem[] =>
  snapshot.map((item) => {
    const latest = latestById.get(item.id);
    if (!latest) return item;
    if (TERMINAL_STATUSES.has(latest.status)) {
      return { ...item, status: latest.status, notes: latest.notes ?? item.notes };
    }
    return item;
  });

/** The row that reads as "current" — in_progress wins, else first pending. */
export const findCurrentTodoItemId = (items: AgentTodoItem[]): number | null => {
  const inProgress = items.find((item) => item.status === 'in_progress');
  if (inProgress) return inProgress.id;
  const pending = items.find((item) => item.status === 'pending');
  return pending?.id ?? null;
};
